export const SET_FORM_FIELD = 'signup/SET_FORM_FIELD';
export const LOADING = 'signup/LOADING';
export const ADD_DEPENDENT = 'signup/ADD_DEPENDENT';
export const ADD_BENEFICIARY = 'signup/ADD_BENEFICIARY';
export const EDIT_DEPENDENT = 'signup/EDIT_DEPENDENT';
export const REMOVE_DEPENDENT = 'signup/REMOVE_DEPENDENT';
export const REMOVE_BENEFICIARY = 'signup/REMOVE_BENEFICIARY';
export const EDIT_BENEFICIARY = 'signup/EDIT_BENEFICIARY';
export const SAVE_INIT_DATA = 'signup/SAVE_INIT_DATA';
export const SAVE_EXPECTED_DATA = 'signup/SAVE_EXPECTED_DATA';
export const SAVE_LOCAL_COPY = 'signup/SAVE_LOCAL_COPY';
export const RESET_SIGNUP = 'signup/RESET_SIGNUP';